import React, { useState, useEffect } from 'react';
import './style.css';
import { useParams } from 'react-router-dom';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { loadServerData, updateAllSheets } from '../../utils/api';
import { removeOfflineData } from '../../x-data-spreadsheet/src/utils/helper';

const OfflineStatus = () => {

  const { id } = useParams();
  const { setSavingData, setIsConflictModalVisible, setServerData } = useDocument();
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOfflineStatus = async () => {

      const isOnline = navigator.onLine;
      setOffline(!isOnline);

      const offlineBoard = JSON.parse(localStorage.getItem('offlineSheets') || '{}');
      const localData = offlineBoard[id]?.data || null;
      const localUpdateTime = offlineBoard[id]?.lastUpdateTime || null;


      if (isOnline && localData) {
        try {

          //server data
          const serverData = await loadServerData(id);
          const serverSheetsData = serverData?.spreadsheetData || [];
          const serverUpdateTime = serverData?.updatedAt || null;
          setServerData(serverData);

          const localDate = localUpdateTime ? new Date(localUpdateTime) : null;
          const serverDate = serverUpdateTime ? new Date(serverUpdateTime) : null;

          // Conflict case: both have data and server is newer
          if (serverSheetsData && localDate && serverDate && (serverDate > localDate)) {
            setIsConflictModalVisible(true);
            return;
          }
          // Auto-sync if no conflict
          else {
            await updateAllSheets(id, localData);
            removeOfflineData(id);

          }
        } catch (e) {
          console.error('Error during offline sync:', e);
        }
      }
    };

    // Initial check
    handleOfflineStatus();

    window.addEventListener('offline', handleOfflineStatus);
    window.addEventListener('online', handleOfflineStatus);

    return () => {
      window.removeEventListener('offline', handleOfflineStatus);
      window.removeEventListener('online', handleOfflineStatus);
    };

  }, [id, setSavingData]);

  if (!offline) return null;

  return (
    <div className="offlineStatus">
      <div>
        No internet? No problem! You're working offline — we’ll sync up when you're reconnected.
      </div>
    </div>
  );
};

export default OfflineStatus;